import { Outlet, RouteObject } from "react-router-dom";

const SiretRoute: RouteObject = {
    path: "siret",
    element: <Outlet />,
    children: [
        {
            index: true,
            async lazy() {
                let { SiretSearchPage } = await import("@/pages/tools/siret/search");
                return { Component: SiretSearchPage };
            }
        }
    ]
};
export default SiretRoute;
